export var Breakpoints = /*#__PURE__*/function (Breakpoints) {
  Breakpoints["breakpoints-xxs"] = "breakpoints-xxs";
  Breakpoints["breakpoints-xs"] = "breakpoints-xs";
  Breakpoints["breakpoints-s"] = "breakpoints-s";
  Breakpoints["breakpoints-m"] = "breakpoints-m";
  Breakpoints["breakpoints-l"] = "breakpoints-l";
  return Breakpoints;
}({});
export var commonBreakpointsValues = {
  'breakpoints-xxs': 320,
  'breakpoints-xs': 413,
  'breakpoints-s': 743,
  'breakpoints-m': 996,
  'breakpoints-l': 1200
};
function createTokens() {
  var commonBreakpointsTokens = {};
  Object.keys(Breakpoints).forEach(function (key) {
    commonBreakpointsTokens[key] = "".concat(commonBreakpointsValues[key], "px");
  });
  return commonBreakpointsTokens;
}
export var commonBreakpointsTokens = createTokens();